/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Name/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Name({
  children,
  viewPath = "/App/Account/Topbar/Options/Content/AvatarAndName/Name"
  
}) {
let globalUserValueData = fromData.useDataFormat({ viewPath,
context: 'global',
path: 'user',
format: fromFormat.personName,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="global.user"
 format="/Data/format.js personName"
 text={globalUserValueData}
 color={dtColorsNeutral900}
 weight="semibold"
 size="xmedium"
 marginLeft={dtSpaceMs}
/>
{children}
</React.Fragment>)
}